import { httpRequest } from '@calendly/http-tools'

const serializeInvitations = (invitations) => (
  Object.assign({}, invitations.map(({ email, role, userGroupRole, userGroupId }) => (
    { user_group_role: userGroupRole, email, role, user_group_id: userGroupId }
  )))
)

export const validateInvitations = ({ invitations, eventTypeIds }) => httpRequest({
  url: '/api/organization/invitations/validate',
  method: 'POST',
  data: {
    invitations: serializeInvitations(invitations),
    managed_event_type_ids: eventTypeIds
  }
})

export const createInvitations = ({
  mfaVerificationGrant,
  recaptchaToken,
  recaptchaV2Token,
  eventTypeIds,
  invitations,
  modal = false,
  verificationCode
}) => httpRequest({
  url: '/api/organization/invitations/bulk',
  method: 'POST',
  data: {
    invitations: serializeInvitations(invitations),
    managed_event_type_ids: eventTypeIds,
    recaptcha_token: recaptchaToken,
    ...(recaptchaV2Token ? { recaptcha_token_version_2: recaptchaV2Token } : {}),
    ...(mfaVerificationGrant ? { mfa_verification_grant: mfaVerificationGrant } : {}),
    verification_code: verificationCode,
    modal
  }
})

export const getManagedEventTypes = ({ sortOrder, page, pageSize, groupId, onlyOrgOwned = false }) => httpRequest({
  url: '/api/organization/managed_event_types',
  method: 'GET',
  params: {
    sort_field: 'name',
    sort_order: sortOrder,
    page,
    page_size: pageSize,
    group_id: groupId,
    only_org_owned: onlyOrgOwned
  }
})
